import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './QuestionSlider.css'

const QuestionSlider = ({ options, callback, currentAnswer, navCallback, currentIndex, lastPosition }) => {
  const [ state, setState] = useState(null);

  const min = parseInt(options.min);
  const max = parseInt(options.max);
  const marks = {};
  const defaultValue = currentAnswer ? parseInt(currentAnswer.answer) : min;

  for (var step = min; step <= max; step++) {
    marks[step] = String(step);
  }

  const handleChange = (val) => {
    setState(val);
  }

  const handleClick = () => {
    callback(state);
  }

  useEffect(() => {
    if(!state) setState(min);
  });

  const handleClickNav = (e) => {
    const direction = e.target.dataset.direction;
    navCallback(state, direction);
  }

  return (
    <>
      {options ? (
        <>
          <div className="div-center w-full sm:w-80 px-4 sm:px-0" id="range">
            <Slider 
              defaultValue={defaultValue}
              min={min}
              max={max}
              onChange={handleChange}
              marks={marks}
            />
          </div>
        </>
      ):null}

      <div className={'text-center mt-20'}>
        {currentIndex !== 0 ?
          <button className={'btn text-medium no-underline text-black inline-block px-1 py-1 bg-white rounded-tl-lg rounded-br-lg py-3 px-6'} onClick={handleClickNav} data-direction={'prev'}>{'Föregående'}</button>
        : null}
        <span className={'mx-4'}>
          <span className={'text-base'}>{ ' ' + (currentIndex+1) } /</span>
          <span className={'text-base'}>{ ' ' + (lastPosition+1) + ' ' }</span>
        </span>
        {currentIndex !== lastPosition ?
          <button className={'btn text-medium no-underline text-black inline-block px-1 py-1 bg-white rounded-tl-lg rounded-br-lg py-3 px-6'} onClick={handleClickNav} data-direction={'next'}>{'Nästa'}</button>
        : null}
      </div>
    </>
  );
};

export default QuestionSlider;
